<template>
    <div>
        <div v-show="!loading">
            <PanZoomComponent v-if="load_panzoom" :svg="svg_loaded" />
            
            <template v-else>
                <div v-html="svg_loaded"></div>
            </template>

            <template v-if="!loading && load_panzoom">
                <b-popover 
                    v-for="zona in zonas"
                    :key="zona.id" 
                    :target="'popover-' + zona.id" 
                    triggers="hover focus"
                >
                    <template slot="title">{{ zona.name ?? zona.nombre }}</template>
                </b-popover>
            </template>
        </div>
        <template v-if="loading">
            <div class="col-12 text-center" style="height: 200px">
                <LoaderComponent/>
            </div>
        </template> 
    </div>
</template>

<script>
import PanZoomComponent from '@/components/svg/components/PanZoomComponent.vue';

export default {
    components : { PanZoomComponent },
    props: {
        zonas: {
            type: Array,
            required: true
        },
        svg: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            svg_loaded : '',
            loading: true,
            can_click: true,
        }            
    },
    created() {
        this.loadSVG(this.svg);
    },
    computed: {
        load_panzoom() {
            var load_panzoom = true

            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if(/windows phone/i.test(userAgent)) {
                load_panzoom = false;
            }

            if(/android/i.test(userAgent)) {
                load_panzoom = false;
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                load_panzoom = false;
            }

            return load_panzoom;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        user() {
            return this.$store.getters.getUser;
        }
    },
    methods : {
        loadSVG(svg) {
            this.svg_loaded = svg;
            var vue_instance = this;

            setTimeout(() => {
                const regions = document.getElementsByClassName("recinto-zona");

                Array.from(regions).forEach(region => {
                    const region_id = region.dataset?.region;

                    if (region_id) {
                        const zona = this.zonas.find(zona => zona.id == region_id);

                        if (zona && typeof zona.esta_disponible !== 'undefined') {
                            if (!zona.esta_disponible) {
                                region.classList.add("no-disponible");
                            }
                        } else {
                            region.classList.add("no-disponible");
                        }

                        region.addEventListener('click', () => {
                            vue_instance.clickRegion(region_id);
                        });
                    }
                });

                this.loading = false;
            }, 1000);
        },
        clickRegion : function(region_id) {
            let zona = this.zonas.find(zona => zona.id == region_id);

            if(zona && zona.esta_disponible) {
                this.$emit('clickZona', zona);
            }            
        },
    }
}
</script>